export class PasswordChecker {
  static calculateStrength(password: string): number {
    if (!password) return 0;

    let strength = 0;
    const checks = {
      length: password.length >= 8,
      hasUpperCase: /[A-Z]/.test(password),
      hasLowerCase: /[a-z]/.test(password),
      hasNumbers: /\d/.test(password),
      hasSpecialChars: /[!@#$%^&*(),.?":{}|<>]/.test(password)
    };

    // Length contribution (up to 0.25)
    strength += Math.min(0.25, (password.length / 32) * 0.25);

    // Character variety contribution (up to 0.75)
    if (checks.hasUpperCase) strength += 0.15;
    if (checks.hasLowerCase) strength += 0.15;
    if (checks.hasNumbers) strength += 0.20;
    if (checks.hasSpecialChars) strength += 0.25;

    return Math.min(1, strength);
  }

  static getPasswordFeedback(password: string): string[] {
    const feedback: string[] = [];
    
    if (password.length < 8) {
      feedback.push('Password must be at least 8 characters long');
    }
    if (!/[A-Z]/.test(password)) {
      feedback.push('Add uppercase letters');
    }
    if (!/[a-z]/.test(password)) {
      feedback.push('Add lowercase letters');
    }
    if (!/\d/.test(password)) {
      feedback.push('Add numbers');
    }
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      feedback.push('Add special characters');
    }

    return feedback;
  }
} 